import { render } from "./EveryoneSocialAccordionSection.vue?vue&type=template&id=ab94a048&scoped=true"
import script from "./EveryoneSocialAccordionSection.vue?vue&type=script&lang=js"
export * from "./EveryoneSocialAccordionSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab94a048"]])

export default __exports__